import { getNoteGenerationErrorContent } from './helpers';
import type { NoteGenerationErrorProps } from './types';

const WRAPPER_CLASS = 'vai-grid vai-w-full vai-items-start vai-gap-4 vai-mt-8';
const CARD_CLASS =
  'vai-p-4 vai-rounded-md vai-bg-red-700 vai-flex vai-flex-col vai-gap-1';
const TITLE_CLASS =
  'vai-font-inter vai-font-semibold vai-text-sm vai-text-zinc-50 vai-mb-2';
const BODY_CLASS = 'vai-font-inter vai-text-sm vai-text-zinc-50/80';

export const NoteGenerationError = (props: NoteGenerationErrorProps) => {
  const content = getNoteGenerationErrorContent(props);

  return (
    <div className={WRAPPER_CLASS}>
      <div className={CARD_CLASS}>
        <p className={`${TITLE_CLASS} vai-mb-4`}>{content.title}</p>
        {content.kind === 'structured' ? (
          <>
            <p className={BODY_CLASS}>{content.intro}</p>
            {content.listItems.length > 0 && (
              <ul className={`vai-list-disc vai-pl-5 vai-mb-4 ${BODY_CLASS}`}>
                {content.listItems.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            )}
            <p className={BODY_CLASS}>
              <span className="vai-font-semibold">Try this:</span>{' '}
              {content.tryThis}
            </p>
          </>
        ) : (
          <p className={`${BODY_CLASS} vai-whitespace-pre-line`}>
            {content.description}
          </p>
        )}
      </div>
    </div>
  );
};
